export default {
  getLogins: (data) => $nuxt.$axios.get($nuxt.$api.host + '/logins', data),
  getAll: (account_uuid, data) => $nuxt.$axios.get($nuxt.$api.host + '/account/' + account_uuid + '/login', data),
  create: (account_uuid, data) => $nuxt.$axios.post($nuxt.$api.host + '/account/' + account_uuid + '/login', data),
  update: (account_uuid, login_uuid, data) =>
    $nuxt.$axios.put($nuxt.$api.host + '/account/' + account_uuid + '/login/' + login_uuid, data),
  delete: (account_uuid, login_uuid) =>
    $nuxt.$axios.delete($nuxt.$api.host + '/account/' + account_uuid + '/login/' + login_uuid),
  makePrimary: (account_uuid, login_uuid) =>
    $nuxt.$axios.post([$nuxt.$api.host, 'account', account_uuid, 'login', login_uuid, 'make-primary'].join('/')),

  getJointLoginsToMigrate: () => $nuxt.$axios.get($nuxt.$api.host + '/migrate-joint-logins/'),
  migrateJointLogins: (login_uuid, data) => $nuxt.$axios.post($nuxt.$api.host + '/migrate-joint-logins/' + login_uuid, data)
};
